import React, { useState } from 'react';
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import LockIcon from '@mui/icons-material/Lock';
import MUITypography from '../Components/MUITypography';
import MUITextField from '../Components/MUITextField';
import axios from 'axios';
import { API_UPDATE_PASSWORD } from '../Util/URLConstants';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { ROUTE_LOGIN } from '../Util/VMConstants';
import Loader from '../Components/Loader';

const UpdatePassword = ({ mode = 'create', userID }) => {
  const isUpdateMode = mode === 'update';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    const reqBody = { user_id: userID, password };
    axios
      .post(API_UPDATE_PASSWORD, reqBody, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        setLoading(false);
        const respData = response.data;
        if (respData.status_code === 200) {
          toast(respData.message);
          navigate('/' + ROUTE_LOGIN, { replace: true });
        } else {
          toast.error(respData.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.warn('Error:', error.message);
      });
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // bgcolor: '#f8f9fa',
        px: 2,
      }}
    >
      <Paper
        elevation={1}
        sx={{
          width: '100%',
          maxWidth: 420,
          px: { xs: 3, sm: 5 },
          py: { xs: 4, sm: 6 },
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 3,
        }}
      >
        <Box display="flex" justifyContent="center" mb={3}>
          <img
            src={'/static/logo.png'}
            alt="Logo"
            style={{
              width: isMobile ? 48 : 64,
              height: isMobile ? 48 : 64,
              objectFit: 'contain',
            }}
          />
        </Box>

        <MUITypography
          variant='h2' 
          fontWeight="bold"
          textAlign="center"
          gutterBottom
          label={isUpdateMode ? 'Update Password' : 'Create Password'}
        />

        <Box component="form" onSubmit={handleSubmit} mt={2}>
          <MUITextField
            label="Password"
            type={showPassword ? 'text' : 'password'}
            fullWidth
            required
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword((prev) => !prev)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <MUITextField
            label="Confirm Password"
            type={showPassword ? 'text' : 'password'}
            fullWidth
            required
            margin="normal"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={!!error}
            helperText={error}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword((prev) => !prev)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            type="submit"
            variant="contained"
            size="large"
            fullWidth
            startIcon={<LockIcon />}
            sx={{
              mt: 4,
              borderRadius: 2,
              py: 1.3,
              fontWeight: 600,
              fontSize: '16px',
            }}
          >
            {isUpdateMode ? 'Update Password' : 'Create Password'}
          </Button>
        </Box>
      </Paper>

      {loading && <Loader loading={loading} />}
    </Box>
  );
};

export default UpdatePassword;
